/**
 * Helpers do Kanban de atendimentos.
 * Observação: `waiting_since` e `last_activity_at` vêm em SEGUNDOS (unix) e
 * chegam como 0 (não null) quando ausentes.
 */

/** Acima disso o card é destacado como "esperando demais". */
export const WAITING_WARN_SECONDS = 60 * 60 * 4; // 4h

/** Peso de urgência por prioridade — maior = mais urgente. */
const PRIORITY_WEIGHT = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

const onlyDigits = value => String(value || '').replace(/\D+/g, '');

export const waitingSeconds = conversation => {
  const since = conversation?.waiting_since || 0;
  if (!since) return 0;
  return Math.max(0, Math.floor(Date.now() / 1000) - since);
};

export const isWaitingTooLong = conversation =>
  waitingSeconds(conversation) >= WAITING_WARN_SECONDS;

/**
 * Status que aparecem no board. Precisa bater com o que o board busca.
 * Sem esse guard: (1) resolver um card pelo menu não o tira do quadro
 * (CHANGE_CONVERSATION_STATUS só muda o status, não remove de allConversations)
 * e (2) conversas carregadas por outras telas (resolvidas/pendentes) vazam.
 */
export const BOARD_STATUSES = ['open'];

/** Filtro do board: status, busca (nome/telefone), responsável, caixa e "só meus". */
export const matchesKanbanFilters = (conversation, filters, currentUserId) => {
  const { search, agentId, inboxId, onlyMine } = filters;
  const assigneeId = conversation.meta?.assignee?.id ?? null;

  if (!BOARD_STATUSES.includes(conversation.status)) return false;
  if (onlyMine && assigneeId !== currentUserId) return false;
  if (agentId === 'unassigned' && assigneeId) return false;
  if (agentId && agentId !== 'unassigned' && assigneeId !== agentId) {
    return false;
  }
  if (inboxId && conversation.inbox_id !== inboxId) return false;

  if (search) {
    const term = search.trim().toLowerCase();
    if (!term) return true;
    const sender = conversation.meta?.sender || {};
    const name = (sender.name || '').toLowerCase();
    const termDigits = onlyDigits(term);
    const matchesName = name.includes(term);
    const matchesPhone =
      termDigits.length >= 3 &&
      onlyDigits(sender.phone_number).includes(termDigits);
    if (!matchesName && !matchesPhone) return false;
  }

  return true;
};

/**
 * Ordena por urgência.
 * order: 'none' (ordem original) | 'desc' (mais urgente primeiro) | 'asc'
 */
export const sortByUrgency = (list, order) => {
  if (order === 'none') return list;
  const direction = order === 'desc' ? -1 : 1;
  return [...list].sort((a, b) => {
    const waitA = waitingSeconds(a);
    const waitB = waitingSeconds(b);
    if (waitA !== waitB) return (waitA - waitB) * direction;
    const priorityA = PRIORITY_WEIGHT[a.priority] || 0;
    const priorityB = PRIORITY_WEIGHT[b.priority] || 0;
    return (priorityA - priorityB) * direction;
  });
};
